import { Box, Button } from '@chakra-ui/react'
import React, { useEffect, useRef } from 'react'
import { FaArrowLeft } from 'react-icons/fa'
import { useFormContext, Controller } from 'react-hook-form'
import { TextEditor } from '../../../../components/TextEditor'

const initialValue = {
  editarH2: false,
  editarParagrafo: false,
}

export function ArticleItem({ article, index }) {
  const { control, setValue, getValues, watch } = useFormContext()

  const [state, dispatch] = React.useReducer((state, action) => {
    switch (action.type) {
      case 'EDITAR_H2':
        return { ...state, editarH2: !state.editarH2, editarParagrafo: false }
      case 'EDITAR_PARAGRAFO':
        return { ...state, editarParagrafo: !state.editarParagrafo, editarH2: false }
      default:
        return state
    }
  }, initialValue)

  // Referências para focar os elementos quando estão em modo de edição
  const h2Ref = useRef(null)
  const paragraphRef = useRef(null)

  // Foco automático ao ativar edição
  useEffect(() => {
    if (state.editarH2 && h2Ref.current) {
      h2Ref.current.focus()
    }
    if (state.editarParagrafo && paragraphRef.current) {
      paragraphRef.current.focus()
    }
  }, [state.editarH2, state.editarParagrafo])

  useEffect(() => {
    setValue(`secoes[${index}].paragrafo`, article.paragrafo)
  }, [article, index, setValue])

  return (
    <Box display="flex" flexDir="column" gap="5" position="relative" mt={10}>
      <Controller
        name={`secoes[${index}].titulo`}
        control={control}
        defaultValue={article.titulo}
        render={({ field }) => (
          <Box
            contentEditable={state.editarH2}
            suppressContentEditableWarning={true}
            ref={h2Ref}
            onBlur={(e) => setValue(`secoes[${index}].titulo`, e.target.innerText)}
            as="h2"
            fontSize="32px"
            fontWeight="bold"
            borderTop="1px solid"
            borderColor="blue.500"
            position="relative"
            _before={{
              content: '""',
              position: 'absolute',
              top: '10px',
              left: '-230px',
              width: '221px',
              height: '26px',
              bgColor: '#95C620',
            }}
          >
            {getValues(`secoes[${index}].titulo`)}
          </Box>
        )}
      />

      <Controller
        name={`secoes[${index}].paragrafo`}
        control={control}
        defaultValue={article.paragrafo}
        render={({ field }) => <TextEditor control={control} {...field} noImage readOnly={!state.editarParagrafo} />}
      />

      <Button
        position="absolute"
        borderColor="gray.700"
        right="-190px"
        borderRadius="sm"
        top="0"
        _hover={{ bg: 'blue.600' }}
        _active={{ bg: 'blue.700' }}
        variant="outline"
        leftIcon={<FaArrowLeft color="#378BBF" />}
        onClick={() => dispatch({ type: 'EDITAR_H2' })}
      >
        Editar (H2)
      </Button>
    </Box>
  )
}
